const seasonColumn = {
    headingLabel: "Season",
    icon: "",
    width: "10%"
};

export const getCueSheetAckSortNode = (col) => {
    switch (col) {
        case "Program": return "show_name";
        case "Season": return "season_name";
        case "Episode #": return "episode_number";
        case "Episode Title": return "episode_title";
        case "Airing": return "airing";
        case "Submit Date": return "submitted_date";
        case "Filename":
        case "File Name": return "file_name";
        default: return "episode_number";
    }
};

export const getCueSheetAckSortType = (col) => {
    if (col === "Episode #") return "Number";
    if (col === "Submit Date") return "Date";
    return "Name";
};

export const warningHeading = {
    headings: [
        {
            headingLabel: "Program",
            icon: "",
            width: "15%",
        },
        seasonColumn,
        {
            headingLabel: "Episode #",
            icon: "sort-alpha-down",
            width: "8%"
        },

        {
            headingLabel: "Episode Title",
            icon: "",
            width: "15%"
        },
        {
            headingLabel: "Airing",
            icon: "",
            width: "8%"
        },
        {
            headingLabel: "Submit Date",
            icon: "",
            width: "10%"
        },
        {
            headingLabel: "Closed",
            icon: "",
            width: "7%",
            inputType: "checkbox",
        },
        {
            headingLabel: "Filename",
            icon: "",
            width: "12%"
        },
        {
            headingLabel: "Ack",
            icon: "",
            width: "7%"
        },
        {
            headingLabel: "XML",
            icon: "",
            width: "7%"
        },
        {
            headingLabel: "CS",
            icon: "",
            width: "7%"
        }

    ],
    dataNodes: ["show_name", "season_name", "episode_number", "episode_title", "airing", "submitted_date", 'check', 'file_name',"Ack", "XML", "CS"],
    primaryKey: "rc_xml_cue_id",
    hyperlinks:["airing", "episode_number"],
    buttonFields: [
        {
            column: "Ack",
            icon: "",
            disabled:true
        },
        {
            column: "XML",
            icon: "",
            disabled:true
        },
        {
            column: "CS",
            icon: "",
            disabled:true
        },
        
    ],
}


export const rejectedHeading = {
    headings: [
        {
            headingLabel: "Program",
            icon: "",
            width: "15%",
        },
        seasonColumn,
        {
            headingLabel: "Episode #",
            icon: "sort-alpha-down",
            width: "10%"
        },

        {
            headingLabel: "Episode Title",
            icon: "",
            width: "15%"
        },
        {
            headingLabel: "Airing",
            icon: "",
            width: "10%"
        },
        {
            headingLabel: "Submit Date",
            icon: "",
            width: "10%"
        },
        {
            headingLabel: "Ack",
            icon: "",
            width: "7%"
        },
        {
            headingLabel: "XML",
            icon: "",
            width: "7%"
        },
        {
            headingLabel: "CS",
            icon: "",
            width: "7%"
        }

    ],
    dataNodes: ["show_name", "season_name", "episode_number", "episode_title", "airing", "submitted_date","Ack", "XML", "CS"],
    primaryKey: "rc_xml_cue_id",
    hyperlinks:["airing", "episode_number"],
    buttonFields: [
        {
            column: "Ack",
            icon: "",
            disabled:true
        },
        {
            column: "XML",
            icon: "",
            disabled:true
        },
        {
            column: "CS",
            icon: "",
            disabled:true
        },
        
    ],
}


export const notAcknowledeHeading = {
    headings: [
        {
            headingLabel: "Program",
            icon: "",
            width: "15%",
        },
        seasonColumn,
        {
            headingLabel: "Episode #",
            icon: "sort-alpha-down",
            width: "10%"
        },

        {
            headingLabel: "Episode Title",
            icon: "",
            width: "15%"
        },
        {
            headingLabel: "Airing",
            icon: "",
            width: "10%"
        },
        {
            headingLabel: "Submit Date",
            icon: "",
            width: "10%"
        },
        {
            headingLabel: "File Name",
            icon: "",
            width: "15%"
        },

    ],
    dataNodes: ["show_name", "season_name", "episode_number", "episode_title", "airing", "submitted_date", "file_name"],
    primaryKey: "rc_xml_cue_id",
    hyperlinks: ["episode_number"],
}